import React, { useState } from 'react';
import { X, Save } from 'lucide-react';
import { Button } from './Button';
import styles from './SaveProjectModal.module.css';

interface SaveProjectModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (resourceName: string, projectName: string, applicantName: string) => void;
    defaultProjectName: string;
}

export function SaveProjectModal({ isOpen, onClose, onSave, defaultProjectName }: SaveProjectModalProps) {
    const [resourceName, setResourceName] = useState('');
    const [projectName, setProjectName] = useState(defaultProjectName);
    const [applicantName, setApplicantName] = useState('');

    if (!isOpen) return null;

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (resourceName.trim()) {
            onSave(resourceName, projectName, applicantName);
            setResourceName('');
            setApplicantName('');
        }
    };

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <h3>Guardar Escenario</h3>
                    <button className={styles.closeButton} onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className={styles.form}>
                    <div className={styles.field}>
                        <label htmlFor="resourceName">Cargo / Rol</label>
                        <input
                            id="resourceName"
                            type="text"
                            value={resourceName}
                            onChange={(e) => setResourceName(e.target.value)}
                            placeholder="Ej: Desarrollador Backend Senior"
                            autoFocus
                            required
                            className={styles.input}
                        />
                    </div>

                    <div className={styles.field}>
                        <label htmlFor="projectName">Proyecto</label>
                        <input
                            id="projectName"
                            type="text"
                            value={projectName}
                            onChange={(e) => setProjectName(e.target.value)}
                            placeholder="Ej: Migración ERP 2024"
                            className={styles.input}
                        />
                        <span className={styles.helpText}>Se agrupará bajo este nombre en la pestaña Proyectos.</span>
                    </div>

                    <div className={styles.field}>
                        <label htmlFor="applicantName">Nombre del Aspirante (Opcional)</label>
                        <input
                            id="applicantName"
                            type="text"
                            value={applicantName}
                            onChange={(e) => setApplicantName(e.target.value)}
                            placeholder="Ej: Juan Pérez"
                            className={styles.input}
                        />
                    </div>

                    <div className={styles.actions}>
                        <Button type="button" onClick={onClose} variant="secondary">
                            Cancelar
                        </Button>
                        <Button type="submit" variant="primary" icon={<Save size={16} />}>
                            Guardar
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
}
